import * as yup from 'yup';
import type { FormDefinition } from '@gov-design-system-ce/react-form-core';
import {
	getFormDefinition,
	useGovForm,
} from '@gov-design-system-ce/react-form-core';
import type { DatovkaApiType } from '@gov-nx/api';
import { useAuthorizationConsentYupSchema } from '@gov-nx/core/hooks';
import {
	dataBoxParams,
	useDataBoxShape,
	useIcNumberShape,
} from '@gov-nx/utils/common';
import type { DataRequest, FormData } from './service.types';

export interface FormInstanceProps {
	dataBoxTypes: DatovkaApiType['typSchranky'][];
	isLowAuthorization: boolean;
}

export function FormInstance({
	dataBoxTypes,
	isLowAuthorization,
}: FormInstanceProps): FormDefinition<FormData> {
	const { getIcNumberShape } = useIcNumberShape();
	const { getDataBoxShape, getDataBoxDefaultValues } = useDataBoxShape({
		types: dataBoxTypes,
	});
	const consentSchema = useAuthorizationConsentYupSchema({
		isConsentRequired: isLowAuthorization,
	});

	const formSchema = yup
		.object({
			...getDataBoxShape({ isRequired: true }),
			ico: getIcNumberShape({
				isRequired: true,
			}),
			druhSubjektu: yup
				.string()
				.oneOf(['Tuzemský subjekt', 'Zahraniční subjekt'])
				.optional(),
		})
		.shape({ __souhlas: consentSchema })
		.required();

	const formMethods = useGovForm<FormData>({
		formSchema,
		defaultValues: {
			...getDataBoxDefaultValues(),
			ico: undefined,
			druhSubjektu: 'Tuzemský subjekt',
		},
	});

	return getFormDefinition({ formMethods, formSchema });
}

export function prepareSubmitData(formData: FormData): DataRequest {
	return {
		params: dataBoxParams(formData),
		body: {
			typVypisu: 'KVALIFIKOVANI_DODAVATELE',
			data:
				formData.druhSubjektu === 'Zahraniční subjekt'
					? {
							dodavatelZahranicniIco: formData.ico,
						}
					: {
							dodavatelTuzemskyIco: formData.ico,
						},
		},
	};
}
